import { GetRecentAction } from "../../Store/firebase/userExtras/$userExtras/recentActions";
import { Command, AssertV, AssertValidate } from "mobx-firelink";
export class RedoAction extends Command {
    Validate() {
        AssertValidate({
            properties: {
                id: { type: "number" },
            },
            required: ["id"],
        }, this.payload, "Payload invalid");
        const { id } = this.payload;
        this.action = GetRecentAction(this.userInfo.id, id);
        AssertV(this.action, "action is null.");
        AssertV(this.action.undone, "Cannot redo an action that has not yet been undone.");
    }
    GetDBUpdates() {
        const { id } = this.payload;
        const updates = this.action.newData;
        updates[`userExtras/${this.userInfo.id}/recentActions/${id}/.undone`] = null;
        return updates;
    }
}
